import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '../..';

interface Props {
  onChange: (e: any) => void;
  value: string;
  name?: string;
  label?: string;
  [x: string]: any;
}

export const SelectDealsStatus = (props: Props) => {
  const { onChange, value, name, ...rest } = props;
  const translate = useTranslate();
  const t = (string: string) => translate(`dealsStatus.${string}`);
  return (
    <SelectInput
      label={t('status')}
      options={[
        { value: '', text: t('ANY') },
        { value: 'CREATED', text: t('CREATED') },
        { value: 'SENDING', text: t('SENDING') },
        { value: 'SENT', text: t('SENT') },
        { value: 'CANCELLING', text: t('CANCELLING') },
        { value: 'CANCELLED', text: t('CANCELLED') },
        { value: 'PAYING_OUT', text: t('PAYING_OUT') },
        { value: 'PAID_OUT', text: t('PAID_OUT') },
        { value: 'FAILED', text: t('FAILED') },
        { value: 'COMPLETED', text: t('COMPLETED') },
        { value: 'INCONSISTENT', text: t('INCONSISTENT') },
      ]}
      onChange={onChange}
      value={value || ''}
      name={name || 'status'}
      {...rest}
    />
  );
};
